export default __webpack_public_path__ + "static/media/404_page_not_found_.7d2baf0b.png";